import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect, useCallback } from "react";
import { Toaster } from "react-hot-toast";
import { profile } from "./api/constants";
import AdminProvider, { useAdmin } from "./context/AdminContext";
import Login from "./Pages/Login";
import Dashboard from "./Pages/Dashboard";
import Admin from "./Pages/Admin";
import Rides from "./Pages/Rides";
import Vehicles from "./Pages/Vehicles";
import Customers from "./Pages/Customers";
import Drivers from "./Pages/Drivers";
import Configurations from "./Pages/Configurations";
import PromoCodes from "./Pages/PromoCodes";
import PromoCodeDetailsPage from "./Pages/PromoCodeDetailsPage";
import Categories from "./Pages/Categories";
import CategoryDetailsPage from "./Pages/CategoryDetailsPage";
import VehicleForm from "./Components/VehicleForm";
import Locations from "./Pages/Locations";
import LocationDetailsPage from "./Pages/LocationDetailsPage";
import LocationForm from "./Components/LocationForm";
import ProtectedRoute from "./Components/ProtectedRoute";
import Form from "./Components/Form";
import CustomerForm from "./Components/CustomerForm";
import VehicleCategoryFares from "./Pages/VehicleCategoryFares";
import BoxComponent from "./Components/Box";
import Details from "./Components/Details";

const AppContent = () => {
  const { adminToken, updateProfile } = useAdmin();

  const fetchProfile = useCallback(
    async (token) => {
      try {
        const response = await profile(token);
        console.log("Profile API Response:", response);

        if (response?.data?.success && response.data.data) {
          updateProfile(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    },
    [updateProfile]
  );

  useEffect(() => {
    const token = adminToken || localStorage.getItem("token");
    if (token) {
      // Call profile API when user is logged in or page is refreshed
      fetchProfile(token);
    }
  }, [adminToken, fetchProfile]);

  return (
    <Router>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: "#363636",
            color: "#fff",
          },
        }}
      />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="dashboard"
          element={
            <ProtectedRoute requiredPermission="dashboard">
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="admin"
          element={
            <ProtectedRoute requiredPermission="admins">
              <Admin />
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-details"
          element={
            <ProtectedRoute requiredPermission="admins">
              <Details entityType="admin" />
            </ProtectedRoute>
          }
        />
        <Route
          path="rides"
          element={
            <ProtectedRoute requiredPermission="rides">
              <Rides />
            </ProtectedRoute>
          }
        />
        <Route
          path="vehicles"
          element={
            <ProtectedRoute requiredPermission="vehicles">
              <Vehicles />
            </ProtectedRoute>
          }
        />
        <Route
          path="customers"
          element={
            <ProtectedRoute requiredPermission="customers">
              <Customers />
            </ProtectedRoute>
          }
        />
        <Route
          path="drivers"
          element={
            <ProtectedRoute requiredPermission="drivers">
              <Drivers />
            </ProtectedRoute>
          }
        />
        <Route
          path="configurations"
          element={
            <ProtectedRoute requiredPermission="configurations">
              <Configurations />
            </ProtectedRoute>
          }
        />
        <Route
          path="promo-codes"
          element={
            <ProtectedRoute requiredPermission="promoCode">
              <PromoCodes />
            </ProtectedRoute>
          }
        />
        <Route
          path="promo-codes/:id"
          element={
            <ProtectedRoute requiredPermission="promoCode">
              <PromoCodeDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="promo-code-details"
          element={
            <ProtectedRoute requiredPermission="promoCode">
              <PromoCodeDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="categories"
          element={
            <ProtectedRoute requiredPermission="vehicles">
              <Categories />
            </ProtectedRoute>
          }
        />
        <Route
          path="categories/:id"
          element={
            <ProtectedRoute requiredPermission="vehicles">
              <CategoryDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="vehicle-categories"
          element={
            <ProtectedRoute requiredPermission="vehicles">
              <Categories />
            </ProtectedRoute>
          }
        />
        <Route
          path="category-details"
          element={
            <ProtectedRoute requiredPermission="vehicles">
              <CategoryDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="vehicle-form"
          element={
            <ProtectedRoute requiredPermission="vehicles">
              <VehicleForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="locations"
          element={
            <ProtectedRoute requiredPermission="locations">
              <Locations />
            </ProtectedRoute>
          }
        />
        <Route
          path="location-details"
          element={
            <ProtectedRoute requiredPermission="locations">
              <LocationDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="location-form"
          element={
            <ProtectedRoute requiredPermission="locations">
              <LocationForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="customer-form"
          element={
            <ProtectedRoute requiredPermission="customers">
              <CustomerForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="details"
          element={
            <ProtectedRoute>
              <Details />
            </ProtectedRoute>
          }
        />
        <Route
          path="customer-details"
          element={
            <ProtectedRoute requiredPermission="customers">
              <Details entityType="customer" />
            </ProtectedRoute>
          }
        />
        <Route
          path="add-admin"
          element={
            <ProtectedRoute requiredPermission="admins">
              <BoxComponent
                display="flex"
                alignItems="center"
                justifyContent="center"
                height="100vh"
              >
                <Form
                  title="Add Admin"
                  onCancel={() => window.history.back()}
                />
              </BoxComponent>
            </ProtectedRoute>
          }
        />
        <Route
          path="vehicle-category-fares"
          element={
            <ProtectedRoute requiredPermission="pricing">
              <VehicleCategoryFares />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default function App() {
  return (
    <AdminProvider>
      <AppContent />
    </AdminProvider>
  );
}
